import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

//升单流水列表
export function getFlowingWater(data) {
  return request(`${BASE_API}/upgrade_order_log/list`, {
    method: 'POST',
    data
  });
}


//导出
export function exportExcel(data){
  return request(`${BASE_API}/upgrade_order_log/list/data_export`,{method:'POST',data,responseType:'blob',download:true});
}